import React from "react";
import LoadingSpinner from "../Utils/Spinner";
import { Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";


export default function MovementFigures({movementData, movementLoaded}){
    const colour = () => {
        if(movementData.total > 0){
            return "table-highlight-green-black-text"
        }
        else if(movementData.total < 0){
            return "table-highlight-red"
        }
        return "table-highlight-orange"
    }

    if(!movementLoaded){
        return <LoadingSpinner/>
    }



    return (
        <div>
            <Title>Movements</Title>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>Total Movement Income</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={colour()}>{movementData.total}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Column>
            </Columns>
        </div>
    );

}